import {BrowserModule} from "@angular/platform-browser";
import {APP_INITIALIZER, NgModule} from "@angular/core";
import {AppComponent} from "./app.component";
import {AppRoutingModule} from "./app.routing.module";
import {NotFoundModule} from "./not_found.component";
import {RestApiCall} from "./core/services/rest-api/restApi.service";
import {AlertsService} from "./services/alerts.service";
import {StartupService} from "./services/startup.service";
import {NgxWebstorageModule} from "ngx-webstorage";
import {HttpClientModule} from "@angular/common/http";

export function startupServiceFactory(startupService: StartupService): Function {
  return () => startupService.load();
}

@NgModule({

  imports: [
    BrowserModule, AppRoutingModule, HttpClientModule, NgxWebstorageModule.forRoot(), NotFoundModule
  ],
  declarations: [
    AppComponent
  ],
  providers: [
    AlertsService,
    RestApiCall,
    StartupService,
    {
      provide: APP_INITIALIZER,
      useFactory: startupServiceFactory,
      deps: [StartupService],
      multi: true
    }],
  bootstrap: [AppComponent]
})

export class AppModule {
}
